
export const contactInfo = {
  name: "TH Skovservice",
  phone: "27 43 23 14",
  email: "Thorsten.hansen94@gmail.com",
  address: "Næssundvej 363, 7960 Karby",
  facebook: "https://www.facebook.com/profile.php?id=100064139131093",
  cvr: "39145308",
};

export const navigation = [
  { name: "Forside", href: "/" },
  { name: "Om os", href: "/om-os" },
  { 
    name: "Ydelser", 
    href: "/ydelser",
    children: [
      { name: "Træfældning", href: "/ydelser/traefaeldning" },
      { name: "Tynding/Sporlægning", href: "/ydelser/traefaeldning-tynding-sporlaegning" },
      { name: "Grenknusning", href: "/ydelser/grenknusning" },
      { name: "Rodfræsning", href: "/ydelser/rodfraesning" },
      { name: "Skovrejsning/Læhegn", href: "/ydelser/skovrejsning-laehegn" },
      { name: "Naturpleje", href: "/ydelser/naturpleje" },
      { name: "Entreprenør", href: "/ydelser/entreprenoer" },
      { name: "Grødeskæring", href: "/ydelser/groedeskaering" },
    ]
  },
  { name: "Galleri", href: "/galleri" },
  { name: "Kontakt", href: "/kontakt" },
];

export const siteMeta = {
  title: "Skovservice og naturpleje på Mors, Thisted og i Thy | Få tilbud",
  description: "TH Skovservice tilbyder træfældning, skovrejsning, grødeskæring og grenknusning på Mors, i Thy, Skive, Thisted og Struer. Kontakt os og få et tilbud.",
};

export const serviceSeoMeta = {
  traefaeldning: {
    title: "Træfældning og topkapning på Mors og i Thy | Få et tilbud",
    description: "Træfældning og topkapning på Mors, i Thy, Skive og Jammerbugt. Vi hjælper med sikker fældning og rådgivning. Kontakt os og få et tilbud."
  },
  "skovrejsning-laehegn": {
    title: "Skovrejsning og læhegn på Mors og i Thy | Få et tilbud i dag",
    description: "Skovrejsning og plantning af læhegn på Mors og i Thy. Vi tilpasser løsningen til din jord og dine ønsker. Få gratis besigtigelse og et uforpligtende tilbud."
  },
  groedeskaering: {
    title: "Grødeskæring af vandløb og grøfter på Mors og i Thy | Få tilbud",
    description: "Grødeskæring på Mors, i Thy, Skive, Struer og Jammerbugt. Vi hjælper med vedligeholdelse af vandløb og grøfter. Kontakt os i dag og hør mere."
  },
  grenknusning: {
    title: "Grenknusning på Mors og i Thy | Skov og naturarealer | Få tilbud",
    description: "Grenknusning på Mors, i Thy, Skive, Struer og Jammerbugt. Vi hjælper med knusning af grene og bevoksning på skov- og naturarealer. Kontakt os her."
  }
};

